import React, { useState } from "react";
import PropTypes from "prop-types";
import ValuePicker from "./ValuePicker";
import { recipeToInitial } from "../recipes";

const RecipeWizard = ({ recipe, onComplete, onBack }) => {
  const init = recipeToInitial(recipe);
  const steps = init.paramSteps;
  const [idx, setIdx] = useState(0);
  const [criteria, setCriteria] = useState(init.criteria);
  const [labelKeyDraft, setLabelKeyDraft] = useState("");
  const step = steps[idx];

  const advance = (next) => {
    const merged = { ...criteria, ...next };
    setCriteria(merged);
    if (idx + 1 >= steps.length) onComplete(merged);
    else { setIdx(idx + 1); setLabelKeyDraft(""); }
  };

  return (
    <div className="space-y-4">
      <button type="button" onClick={onBack} className="text-xs text-text-2 hover:text-text underline">← Back to recipes</button>
      <p className="text-sm font-medium text-text">{step.prompt}</p>
      {step.type === "pick-label-key" && (
        <div className="flex items-center gap-2">
          <input aria-label="label key" value={labelKeyDraft} onChange={(e) => setLabelKeyDraft(e.target.value)}
            placeholder="e.g. cost_center" className="border border-border rounded-ctrl px-3 py-1.5 text-sm" />
          <button type="button" disabled={!labelKeyDraft.trim()}
            onClick={() => {
              // Update the first label refinement's key.
              const refs = (criteria.refinements || []).map((r) =>
                r.dim === "label" ? { ...r, key: labelKeyDraft.trim() } : r
              );
              advance({ refinements: refs });
            }}
            className="px-3 py-1.5 text-sm rounded-ctrl bg-primary text-white hover:bg-primary-hover disabled:opacity-40">Next</button>
        </div>
      )}
      {step.type === "pick-one-to-narrow" && (
        <ValuePicker
          facet={step.facet}
          labelKey=""
          selected={[]}
          onToggle={(value) => {
            // For project scope narrowing: add the selected project to scope.projects.
            if (step.facet === "project") {
              const prevProjects = criteria.scope?.projects || [];
              advance({ scope: { projects: [...prevProjects, value] } });
            } else {
              // For other dimensions: add as a refinement.
              const newRef = { dim: step.facet, values: [value] };
              advance({ refinements: [...(criteria.refinements || []), newRef] });
            }
          }}
        />
      )}
    </div>
  );
};

RecipeWizard.propTypes = { recipe: PropTypes.object.isRequired, onComplete: PropTypes.func.isRequired, onBack: PropTypes.func.isRequired };
export default RecipeWizard;
